import { Injectable } from "@angular/core";
import { Platform, PopoverController } from "@ionic/angular";
import { PopoverClass } from "src/app/popovers/popover-factory";
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from "../config/config.service";
import { UtilsService } from "../utils/utils.service";
import { EventsService } from "../event/event.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";

@Injectable({
  providedIn: "root",
})
export class AppLinksService {
  public window;
  public isMobileApp = false;

  constructor(
    //public iab: InAppBrowser,
    public platform: Platform,
    public navigator: Navigator,
    public config: ConfigService,
    public utils: UtilsService,
    private iab: InAppBrowser,

    public events: EventsService
  ) {
    this.isMobileApp = this.platform.is("capacitor")||this.platform.is('android');
  }

  public openExternalPage(url) {
    if (!this.window) {
      this.window = window.open(url, "_system");
    } else {
      this.window.close();
      this.window = window.open(url, "_system");
    }

    // if (this.platform.is('capacitor') && this.platform.is('ios')) return this.iab.create(url, "_system", "location=no,enableviewportscale=yes");
    return this.window;
  }

  public openDownloadablePage(url) {
    this.window = window.open(url, "_parent");
    return this.window;
  }

  public openInNewWindow(url, newTab = false) {
    //if(this.platform.is('cordova')) return this.iab.create(url, '', 'location=no,footer=no,hardwareback=yes,hidenavigationbuttons=no');
    if (this.platform.is("ios") && this.platform.is("mobileweb"))
      return window.open(url);
    if (this.platform.is("mobileweb") && !this.platform.is("cordova"))
      return window.open(url, "_system");
    if (newTab) return window.open(url, "_blank");

    let w = window.innerWidth;
    let h = window.innerHeight;
    return window.open(url, "_blank", `height=${h},width=${w}`); // ,noopener,noreferrer
  }

  goToFeatureOfferTermsLink(url: string) {
    return this.openPopover(url, "Terms & Conditions");
  }

  openPopover(url: string, title?: string) {
    this.navigator.openPopover(
      "PopoverWebview",
      { url: url, title: title },
      this.isMobileApp ? "standard-popover mobile-webview" : "standard-popover"
    );
  }

  openDarkPopover(url: string, title?: string) {
    this.navigator.openPopover(
      "PopoverDarkWebview",
      { url: url, title: title },
      "standard-popover"
    );
  }

  loadWebview(url: string): any {
    return this.events.publish("event:webview:load", url);
  }

  popupToDialog(url) {
    return this.navigator.navigateTo(
      "ExternalLinkContentComponent",
      { forceModal: true, multipleModals: true },
      { url }
    );
  }

  public openMatchedExternalLinksPopover(code: any, title?: string): any {
    const externalLinks = this.config
      .getExternalLinks()
      .payload.filter((link) => link.code == code);

    const url = externalLinks[0].url;
    return this.openPopover(url, title);
  }
}
